import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'gas-table-checkbox',
  templateUrl: `./gas-table-checkbox.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasTableCheckboxComponent {
  @Input()
  public set isSelected(value: boolean) {
    this.isSelectedSubject$.next(value);
  }

  public get isSelected(): boolean {
    return this.isSelectedSubject$.value;
  }

  @Input()
  public set isDisabled(value: boolean) {
    this.isDisabledSubject$.next(value);
  }

  @Output('selected')
  public selected$ = new EventEmitter<Event>();

  public isSelected$: Observable<boolean>;
  public isDisabled$: Observable<boolean>;

  private isSelectedSubject$ = new BehaviorSubject<boolean>(false);
  private isDisabledSubject$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.isSelected$ = this.isSelectedSubject$.asObservable();
    this.isDisabled$ = this.isDisabledSubject$.asObservable();
  }

  public select(event: Event, isDisabled: boolean): void {
    if (isDisabled) {
      return;
    }
    this.selected$.emit(event);
  }
}
